<script setup lang="ts">
/** A page's title row: heading and subtitle on the left, primary controls on the right. */
defineProps<{ title: string }>()
</script>

<template>
  <div class="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
    <div class="flex min-w-0 flex-col gap-[var(--space-tight)]">
      <h1 class="text-[length:var(--text-step-6)] font-semibold text-[color:var(--color-text)]">
        {{ title }}
      </h1>
      <p v-if="$slots.subtitle" class="text-[length:var(--text-step-2)] text-[color:var(--color-text-muted)]">
        <slot name="subtitle" />
      </p>
    </div>
    <div v-if="$slots.actions" class="flex flex-wrap items-center gap-[var(--space-inline)]">
      <slot name="actions" />
    </div>
  </div>
</template>
